import { render } from "./HeroiconsOutlineChevronDoubleDown.vue?vue&type=template&id=ebd017fa"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleDown.vue"]])

export default __exports__